<template>
  <b-modal
    @shown="modal(true)"
    @hidden="modal(false)"
    :hide-footer="!getExibeLp"
    size="lg"
    id="ModalResumoTecnico"
  >
    <Header titulo="Resumo Técnico" cor="azul" :close="cancelar" slot="modal-header" />
    <div class="modal-resumo-corpo">
      <div class="modal-resumo-menu">
        <div
          :class="[
            'modal-resumo-menu-item',
            { 'modal-resumo-menu-selecionado': item.titulo == conteudoSelecionado.titulo }
          ]"
          v-for="(item, index) in conteudo"
          :key="index"
          @click="seleciona(item)"
        >
          {{ item.titulo }}
        </div>
      </div>
      <div class="modal-resumo-info">
        <h2>Assista o video explicativo</h2>
        <iframe
          allowfullscreen
          class="modal-resumo-video"
          v-if="modalAberto"
          src="https://www.youtube.com/embed/7u92RTekTb4?mute=1"
          frameborder="0"
        ></iframe>
        <div
          v-if="conteudoSelecionado.texto"
          class="modal-resumo-texto"
          v-html="conteudoSelecionado.texto"
        ></div>
      </div>
    </div>
    <template slot="modal-footer">
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Não mostrar novamente"
        icone="times"
        :click="handleClick"
        cor="azul"
      />
    </template>
  </b-modal>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";

import Api from "@/services/api";

export default {
  name: "ModalResumoTecnico",
  components: {
    BotaoPadrao,
    Header
  },
  props: {
    getExibeLp: Boolean
  },
  data() {
    return {
      modalAberto: false,
      conteudoSelecionado: {},
      conteudo: [
        {
          titulo: "Pesquisa",
          texto:
            "Tenha à sua disposição mais de 27 mil códigos NCM/NBM, considerando a correlação entre todas as versões do SH (1995-2022), a descrição da TIPI e a expressa na legislação."
        },
        {
          titulo: "Compare",
          texto:
            "Após preencher os dados, receba em sua tela até 3 cenários diferentes simultaneamente e analise o melhor caso para sua empresa."
        },
        {
          titulo: "Cadastro",
          texto:
            "Cadastre produtos para facilitar a consulta no cenário, além de auditar a vigência/alteração do código NCM/NBM e sua correlação com o CNAE."
        },
        {
          titulo: "Empresas",
          texto:
            "Cadastre empresas para facilitar a consulta no cenário, além de auditar a correlação da NCM da operação com o CNAE da empresa."
        },
        {
          titulo: "Cenários",
          texto:
            "Consulte operação no mercado interno (interna/interestadual) e mercado externo (importação/exportação) realizada por estabelecimento industrial, atacadista ou varejista."
        },
        {
          titulo: "Tributos",
          texto:
            "ICMS, FCP, IPI, PIS/COFINS, Imposto de Importação, Imposto de Exportação, CIDE-Combustíveis e Defesa Comercial."
        }
      ]
    };
  },
  created() {
    window.addEventListener("keydown", this.handleKey);
    this.conteudoSelecionado = this.conteudo[0];
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },
  watch: {
    modalAberto() {
      this.conteudoSelecionado = this.conteudo[0];
    }
  },
  methods: {
    handleKey(event) {
      let modal = document.getElementById("ModalResumoTecnico");
      if (modal.classList.contains("show")) {
        if (event.key === "Enter") {
          this.handleClick();
        }
      }
    },
    handleClick() {
      new Api().get("Usuario/updateExibirLP");
      this.$root.$emit("bv::hide::modal", "ModalResumoTecnico");
    },
    cancelar() {
      this.$root.$emit("bv::hide::modal", "ModalResumoTecnico");
    },
    modal(bool) {
      this.modalAberto = bool;
    },
    seleciona(item) {
      this.conteudoSelecionado = item;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-resumo-corpo {
  display: flex;
  justify-content: space;
}
.modal-resumo-menu {
  // background: red;
  width: 200px;
}
.modal-resumo-menu-item {
  width: 100%;
  background: var(--cinza02);
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
  border-radius: 10px;
  box-shadow: 2px 2px 4px var(--sombra0);
  transition: background 0.3s ease-in-out;
  cursor: pointer;
  &:hover {
    background: var(--cinza04);
  }
}
.modal-resumo-menu-selecionado {
  color: var(--branco);
  background: var(--azul4);
  &:hover {
    background: var(--azul4);
  }
}
.modal-resumo-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 14px;
  h2 {
    font-family: "Roboto Condensed";
    font-weight: 700;
    color: var(--azul4);
    font-size: 20px;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
}
.modal-resumo-video {
  width: 100%;
  aspect-ratio: 16/9;
}
.modal-resumo-texto {
  margin-top: 10px;
}
</style>
